/**
 * Created by Jie Gao on 2019-01-29.
 */
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StarStruckReelAreaView} from "./StarStruckReelAreaView";
import {TimelineLite} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {StarStruckReelAreaEvents} from "./events/StarStruckReelAreaEvents";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";

export interface ISlowMotionStopConfig {
    reelId:number;
    startPos:number;
    bounceUpwards:boolean;
}

export interface ILiftReelConfig {
    reelId:number;
    bounceStartPos:number;
}

export class StarStruckReels extends Reels {
    constructor() {
        super();
    }

    protected addEventListeners():void {
        super.addEventListeners();
        EventHandler.addEventListener(this, StarStruckReelAreaEvents.LIFT_REEL, (event:GameEvent) => this.liftReels(event.params[0]));
        EventHandler.addEventListener(this, StarStruckReelAreaEvents.SLOW_MOTION_STOP, (event:GameEvent) => this.onSlowMotionStop(event.params[0]));
    }

    public liftReels(liftReelConfig:ILiftReelConfig):void {
        (<StarStruckReelAreaView>Reels._reelAreaView).liftReelUp(Reels._reels[liftReelConfig.reelId].view, liftReelConfig.bounceStartPos);
        EventHandler.dispatchEvent(new GameEvent(StarStruckReelAreaEvents.SLOW_MOTION_STOPPING));
    }

    public onSlowMotionStop(slowMotionStopConfig:ISlowMotionStopConfig):TimelineLite {
        return (<StarStruckReelAreaView>Reels._reelAreaView).onSlowMotionStop(Reels._reels[slowMotionStopConfig.reelId].view, slowMotionStopConfig.startPos, slowMotionStopConfig.bounceUpwards);
    }

    // protected stopSpin(spinStopOffset:number):void {
    //     let stopDelay:number = 0;
    //     let firstReel:boolean = true;
    //     for(let i:number = 0; i < 3; i++) {
    //         if(this._reels[i].currentSpinState === ReelAnimationState.SPIN || this._reels[i].currentSpinState === ReelAnimationState.INACTIVE) {
    //             const stopSpinData:IReelStopSpinData = {
    //                 quickStop : this._quickStop,
    //                 fastSpin : this._fastSpin,
    //                 active : this._activeReels[i],
    //                 spinStopOffset : i
    //             };
    //             stopDelay = this._reels[i].stopSpin(stopSpinData, stopDelay + this.getStopDelayDelta(i, stopSpinData));
    //             if(firstReel || (this.getReelNearWinState(0) && this._quickStop)) {
    //                 stopDelay += this._reels[i].currentSpinStepLeftTime;
    //                 firstReel = false;
    //             }
    //
    //         } else if(this._reels[i].currentSpinState === ReelAnimationState.STOP_SPIN) {
    //             this._reels[i].quickStopStoppingSpin();
    //             if(firstReel || (this.getReelNearWinState(0) && this._quickStop)) {
    //                 stopDelay += this._reels[i].currentSpinStepLeftTime;
    //                 firstReel = false;
    //             }
    //         }
    //     }
    // }
}